define('viewModels/privileged/qm/RecordingRestoreDetailsView',[
    'lib/knockout',
    'lib/lodash4',
    'lib/bluebird',
    'moment',
    'services/qualityManagementService',
    'services/qm/qualityAuth',
    'util/errorCallbackFactory',
    'viewModels/ViewModel'
], function (ko,
             _,
             Promise,
             moment,
             qualityManagementService,
             qualityAuth,
             errorCallbackFactory,
             ViewModel) {
    'use strict';

    var RecordingRestoreDetailsView = ViewModel.extend(function (recordingObservable) {
        var self = this;

        self.isSaving = ko.observable(false);
        self.recording = recordingObservable;
        self.restorePeriod = null;
        self.canRestore = self.computed(function () {
            return recordingObservable() && recordingObservable().media === 'screen' ? qualityAuth.canRestoreScreenRecordings() : qualityAuth.canRestoreRecording();
        });

        var PERIODS = [
            { id: 1, name: ko.i18n.renderString('playback.archivePeriods.1day')},
            { id: 7, name: ko.i18n.renderString('playback.archivePeriods.7days')},
            { id: 30, name: ko.i18n.renderString('playback.archivePeriods.30days')}
        ];

        var FILESTATE_ARCHIVED = "ARCHIVED";
        var FILESTATE_RESTORING = "RESTORING";
        var FILESTATE_RESTORED = "RESTORED";
        var FILESTATE_UPLOADING = "UPLOADING";
        var FILESTATE_DELETED = "DELETED";

        self.selectedPeriod = ko.observable();

        self.isArchived = self.computed(function() {
            return self.recording() &&
                self.recording().fileState &&
                ko.unwrap(self.recording().fileState) === FILESTATE_ARCHIVED;
        });

        self.isRestoring = self.computed(function () {
            return self.recording() &&
                self.recording().fileState &&
                ko.unwrap(self.recording().fileState) === FILESTATE_RESTORING;
        });

        self.isRestored = self.computed(function () {
            return self.recording() &&
                self.recording().fileState &&
                ko.unwrap(self.recording().fileState) === FILESTATE_RESTORED;
        });

        self.isUploading = self.computed(function(){
            return self.recording() &&
                self.recording().fileState &&
                ko.unwrap(self.recording().fileState) === FILESTATE_UPLOADING;
        });

        self.isDeleted = self.computed(function(){
            return (self.recording() &&
                self.recording().fileState &&
                ko.unwrap(self.recording().fileState) === FILESTATE_DELETED) ||
                (!self.recording() || !self.recording().fileState);
        });

        self.orgRestoresRemaining = self.computed(function() {
            if (self.recording() &&
                self.recording().remainingRestorationsAllowedForOrg) {
                return ko.unwrap(self.recording().remainingRestorationsAllowedForOrg);
            }
            return 0;

        });

        self.canSetRestoreDays = self.computed(function () {
            return (self.orgRestoresRemaining() > 0) && (self.isRestored() || self.isArchived());
        });

        var setRestoreDays = function(restorePeriod) {
            if (self.isSaving()) { return; }

            var recording = ko.toJS(self.recording);
            if (recording) {
                var opts = {};
                recording.archiveDate = moment().add(restorePeriod, 'day').toISOString();
                self.isSaving(true);
                recording.fileState = FILESTATE_RESTORING;
                qualityManagementService.updateRecording(recording, opts)
                .then(function(result) {
                        //updateRecording results in call to backend playback service with a transcode type of "None" so
                        //media Uris are not generated, copy them from the original before updating
                        if(self.recording().mediaUris && !result.mediaUris) {
                            result.mediaUris = self.recording().mediaUris;
                        }
                        if(self.recording().mediaUri && !result.mediaUri) {
                            result.mediaUri = self.recording().mediaUri;
                        }
                        self.recording(result);
                    })
                .catch(errorCallbackFactory.createCallback({ namespace: "playback.archive.restoreRequest"}))
                .finally(function () {
                    self.isSaving(false);
                });
            }
        };

        self.restoreExpireDate = self.computed(function () {
            if (self.recording() &&
                self.isRestored() &&
                self.recording().restoreExpirationTime) {
                return self.recording().restoreExpirationTime;
            }
        });

        self.subscribe(self.selectedPeriod, function (newValue) {
            if (newValue && newValue.id != self.restorePeriod) {
                self.restorePeriod = newValue.id;
                setRestoreDays(newValue.id);
            }
        });

        self.daysLeft = self.computed(function () {
            var expireDate = self.restoreExpireDate();
            if (expireDate) {
                return Math.round(moment(expireDate).diff(moment(), 'days', true));
            }
            return 0;
        });

        self.searchPeriods = function (searchTerm) {
            var filteredPeriods = PERIODS;
            if (searchTerm.length > 0) {
                filteredPeriods = _.filter(PERIODS, function (period) {
                    return period.name.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0;
                });
            }
            return Promise.resolve(filteredPeriods);
        };
    });

    return RecordingRestoreDetailsView;
});

